import {Component, Input} from '@angular/core';
import {NgStyle} from '@angular/common';

@Component({
  selector: 'app-banniere',
  imports: [
    NgStyle
  ],
  templateUrl: './banniere.component.html',
  styleUrl: './banniere.component.scss'
})
export class BanniereComponent {
  @Input() couleur!: string;
}
